import React from "react";
import logo from "../assets/img/Aays.png";
import heroImage from "../assets/img/loginPage.gif";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SigninWidget.scss";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Overview from "../../components/overview/Overview";
import { loginRequest } from "./authConfig"; // make sure this points to your loginRequest

const loginStageStyle = {
  backgroundImage: `url(${heroImage})`,
};

const Login = () => {
  const { instance } = useMsal(); // Access MSAL instance from context

  const login = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest); // Trigger login popup
      console.log("Login successful", loginResponse);
      const account = loginResponse && loginResponse.account;
      const idtoken = account && account.idToken;
      const userEmail =
        loginResponse && loginResponse?.idTokenClaims?.preferred_username;
      const userName = loginResponse && loginResponse?.idTokenClaims?.name;
      localStorage.setItem("userinfo", userEmail.toLowerCase());
      localStorage.setItem("userName", userName);
      localStorage.setItem(
        "access-token-storage",
        JSON.stringify({ accessToken: idtoken })
      );
    } catch (error) {
      console.error("Login failed", error);
    }
  };
  return (
    <>
      <AuthenticatedTemplate>
        <Overview />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="Buttons">
          <div className="loginPage">
            <div className="login_body_content">
              <div className="login_shell">
                <section
                  className="login_stage"
                  style={loginStageStyle}
                >
                  <div className="pointer-events-none absolute top-0 left-0 right-0 z-10 h-screen bg-gradient-to-r from-brandPurple/20 to-brandPurple/10"></div>
                  <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-10 h-6 bg-gradient-to-r from-brandPurple to-brandPurple"></div>
                  <div className="relative z-20 grid w-full place-items-center">
                    <div className="login_card login_card_centered">
                      <img src={logo} alt="Aadi" className="login_card_logo" />
                      <div className="text-center">
                        <p className="login_card_label">AAYS AUDIT PLATFORM</p>
                        <h1 className="login_card_title">Welcome back!</h1>
                        <p className="text-[14px] text-[#ffffff] text-center mt-4">
                          Sign in to access the AAYS Audit Platform and continue.
                        </p>
                      </div>
                     

                      <button className="btn_login" onClick={login}>
                        <span className="microsoft_mark" aria-hidden="true">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </span>
                        Sign In with Microsoft Account
                      </button>

                    
                       <p className="login_support_text text-center mt-4">
                        Access to this system is limited. Contact
                        <a
                          rel="noreferrer"
                          target={"_blank"}
                          href="mailto:anshuman.bhar@aaysanalytics.com"
                        >
                          anshuman.bhar@aaysanalytics.com
                        </a>
                        for account enablement and onboarding support.
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
};

export default Login;
